import { CUSTOMER_HOME_PATH } from './constants/post-auth-destination-constants';

export function resolvePostAuthDestination(requestedPath?: string | null): string {
  return requestedPath || CUSTOMER_HOME_PATH;
}

export function buildCustomerHomePath(accountId?: string): string {
  if (!accountId) {
    return CUSTOMER_HOME_PATH;
  }

  return `${CUSTOMER_HOME_PATH}?aid=${encodeURIComponent(accountId)}`;
}
